import React, { ReactElement } from 'react'
import CommonSectionItem, {
  CustomImage,
} from 'components/Organization/LandingPageCommonComponents/CommonSectionItem'
import SchoolControllingImage from 'images/organization/industries/schools/school-controlling.svg'
import UseCaseDivider from 'components/Organization/Industries/Common/UseCaseDivider'
import UseCaseItem from 'components/Organization/Industries/Common/UseCaseItem'
import K12Icon from 'images/organization/industries/schools/useCases/k-12.svg'
import SchoolDistrictsIcon from 'images/organization/industries/schools/useCases/school-districts.svg'
import CollegesUniversitiesIcon from 'images/organization/industries/schools/useCases/colleges-universities.svg'
import StyledLink from 'components/Organization/LandingPageCommonComponents/StyledLink'

export default function InternetSafety(): ReactElement {
  return (
    <CommonSectionItem
      customImage={
        <CustomImage
          svg={SchoolControllingImage}
          descriptiveText="How schools use Control D for internet safety illustration"
        />
      }
      title="How schools use Control D for internet safety"
      description={
        <>
          <StyledLink to="/blog/web-content-filtering-platforms-for-schools/">
            Schools, districts, and colleges
          </StyledLink>{' '}
          rely on Control D for customized content filtering and CIPA compliance:
        </>
      }
      sx={{
        mt: '12rem',
        alignItems: 'flex-start',
        px: [0, '1.6rem', 0],
      }}
      useCases={
        <>
          <UseCaseDivider />
          <UseCaseItem
            svg={K12Icon}
            title="K-12 Schools"
            description="Keep students safe, block distractions, and enforce school-wide internet policies."
          />
          <UseCaseDivider />
          <UseCaseItem
            svg={SchoolDistrictsIcon}
            title="School Districts"
            description="Centrally manage content filtering for multiple schools with easy district-wide control."
          />
          <UseCaseDivider />
          <UseCaseItem
            svg={CollegesUniversitiesIcon}
            title="Colleges & Universities"
            description="Protect campus networks while allowing access to academic resources."
          />
          <UseCaseDivider sx={{ mb: 0 }} />
        </>
      }
    />
  )
}
